var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',[_c('b-col',[_c('b-card',{staticClass:"shadow"},[_c('employee-calendar')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }